import { useIntl } from 'react-intl';

import { CSSHighlight } from '../components/CSSHighlight.js';
import { useFilterFieldContext } from '../hooks/useFilterFieldContext.js';
import { filterFieldMessages } from '../messages.js';
import * as suggestionStyles from './Suggestion.sty.js';
import { Suggestion } from './Suggestion.js';
import * as suggestionGroupStyles from './SuggestionGroup.sty.js';
import { SuggestionGroup } from './SuggestionGroup.js';

/**
 * @internal
 */
export function FallbackKeySuggestionGroup() {
  const { fallbackKeySuggestionValues, statementSuggestionValues, term } =
    useFilterFieldContext();
  const intl = useIntl();

  if (
    fallbackKeySuggestionValues.length === 0 &&
    statementSuggestionValues.length === 0
  ) {
    return null;
  }

  return (
    <SuggestionGroup
      aria-label={intl.formatMessage(
        filterFieldMessages.suggestions.a11y.statementSuggestions,
      )}
    >
      <CSSHighlight
        className={suggestionGroupStyles.builtInSuggestionsContainer}
        term={term ?? ''}
        selector={`.${suggestionStyles.statementSuggestionValue}`}
        highlightName="filterfield-suggestions-highlight"
      >
        {statementSuggestionValues?.map((suggestion, index) => (
          <Suggestion
            {...suggestion}
            key={suggestion.value ?? `${index}-statementsuggestions`}
            data-strato-filter-field-virtual-focus-type="statement-suggestion"
          />
        ))}
      </CSSHighlight>
      {fallbackKeySuggestionValues?.map((suggestion, index) => (
        <Suggestion
          {...suggestion}
          key={suggestion.value ?? `${index}-fallbackkeysuggestions`}
          className={suggestionStyles.defaultSuggestion}
          data-strato-filter-field-virtual-focus-type="fallbackkey-suggestion"
        />
      ))}
    </SuggestionGroup>
  );
}
